<div class="tw:p-8 tw:max-h-[90vh] overflow-y-auto">
    <lib-gesuch-popup-heading>{{
        'DOKUMENTE_UEBERNEHMEN' | translate
    }}</lib-gesuch-popup-heading>

    @if (dokumenteZuUebernehmenRes.isLoading()) {
        <div class="tw:flex tw:justify-center tw:items-center">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
    } @else if (
        groupedDokumenteZuUebernehmenTyps() === undefined ||
        groupedDokumenteZuUebernehmenTyps()?.length === 0
    ) {
        <span class="mb-4">
            {{ 'KEINE_DOKUMENTE_ZU_UEBERNEHMEN' | translate }}
        </span>
    } @else {
        <p translate>DOKUMENTE_UEBERNEHMEN_HELPTEXT</p>
        <p class="tw:mb-4"><b translate>DOKUMENTE_UEBERNEHMEN_WARNUNG</b></p>
        <mat-divider class="tw:pb-6"></mat-divider>

        @for (
            grundWithDocuments of groupedDokumenteZuUebernehmenTyps();
            track grundWithDocuments
        ) {
            <h2>
                {{
                    'DOKUMENT_GRUND_TYP_' + grundWithDocuments.grundTyp
                        | translate
                }}
            </h2>
            <div class="tw:grid tw:grid-cols-[2fr_1fr_1fr] tw:mb-8 tw:min-w-0">
                @for (
                    grundWithDocumentDecisions of grundWithDocuments.grundeWithDocumentDecisions;
                    track grundWithDocumentDecisions
                ) {
                    <!-- Group title spanning full width -->
                    <h3 class="tw:col-span-3 tw:mt-4 tw:mb-2 tw:break-words">
                        {{
                            grundWithDocumentDecisions.grund.dokumentGrundTyp +
                                '_' +
                                grundWithDocumentDecisions.grund.dokumentTyp
                                | translate
                        }}
                    </h3>
                    <span class="tw:pb-2" translate>DOK_DOKUMENT</span>
                    <span class="tw:pb-2 tw:mr-4" translate>{{
                        'DOKUMENT_GRUND_TYP_TAG_' + grundWithDocuments.grundTyp
                    }}</span>
                    @if (
                        hasPersonenbezogeneGrunde(grundWithDocuments.grundTyp)
                    ) {
                        <span class="tw:pb-2" translate>DOK_FUER</span>
                    } @else {
                        <span class="tw:pb-2"></span>
                    }
                    @for (
                        dokumentEntscheid of grundWithDocumentDecisions.dokumente;
                        track dokumentEntscheid
                    ) {
                        <!-- Dokument row -->
                        <div class="tw:gap-2 tw:pr-6">
                            <mat-checkbox
                                [(ngModel)]="dokumentEntscheid.erneuern"
                                ><span
                                    [title]="
                                        dokumentEntscheid.dokument.filename
                                    "
                                >
                                    {{ dokumentEntscheid.dokument.filename }}
                                </span></mat-checkbox
                            >
                        </div>

                        <span class="tw:flex tw:items-center">
                            {{ grundWithDocumentDecisions.grund.tag }}
                        </span>

                        <span class="tw:flex tw:items-center">
                            @if (
                                grundWithDocumentDecisions.grund
                                    .personNumber !== null
                            ) {
                                {{
                                    grundWithDocumentDecisions.grund
                                        .personNumber === 1
                                        ? gesuchmodelManager
                                              .getGesuch()
                                              .gesuchsteller1.extractFullName()
                                        : gesuchmodelManager
                                              .getGesuch()
                                              .gesuchsteller2.extractFullName()
                                }}
                            }
                        </span>
                    }
                }
            </div>
            <mat-divider />
        }
    }
    <div class="tw:flex tw:justify-center tw:mt-12">
        @if (groupedDokumenteZuUebernehmenTyps()?.length > 0) {
            <button class="dv-btn tw:mr-2" (click)="erneuern()">
                {{ 'UEBERNEHMEN' | translate }}
            </button>
        }

        <button class="dv-btn cancel-button" type="button" (click)="cancel()">
            {{ 'CANCEL' | translate }}
        </button>
    </div>
</div>
